
import { apiSlice } from '../../app/api/apiSlice'
// Automatically created using reduxslicer by Simo Virokannas, 2023

export const platetypeApi = apiSlice.injectEndpoints ({ 
  endpoints: (builder) => ({
    listPlateTypes: builder.query ({
      query: (params) => `v2/platetype/${params ? "?" + new URLSearchParams(Object.entries(params)).toString() : ""}`,
      keepUnusedDataFor: 1,
      providesTags: ["PlateType"]
    }),
    getPlateType: builder.query ({
      query: (platetype_id) => `v2/platetype/${platetype_id}/`,
      keepUnusedDataFor: 1,
      providesTags: ["PlateType"]
    }),

    updatePlateType: builder.mutation ({
      query: ({platetype_id, data}) => ({
        url: `v2/platetype/${platetype_id}/`,
        method: 'PUT',
        body: data
      }),
      invalidatesTags: ["PlateType"]
    }),
    deletePlateType: builder.mutation ({
      query: (platetype_id) => ({
        url: `v2/platetype/${platetype_id}/`,
        method: 'DELETE'
      }),
      invalidatesTags: ["PlateType"]
    }),
    createPlateType: builder.mutation ({
      query: (data) => ({
        url: `v2/platetype/`,
        method: 'POST',
        body: data
      }),
      invalidatesTags: ["PlateType"]
    }),
  })
})


export const {
  useListPlateTypesQuery,
  useLazyListPlateTypesQuery,
  useGetPlateTypeQuery,
  useLazyGetPlateTypeQuery,

  useUpdatePlateTypeMutation,
  useDeletePlateTypeMutation,
  useCreatePlateTypeMutation
} = platetypeApi
